
import NrIcon from '../NrIcon/NrIcon.vue'

export default {
  name: 'NrPill',
  props: {
    label: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'normal'
    },
    pillColor: {
      type: String,
      default: 'black'
    }
  },
  components: {
    NrIcon
  },
  computed: {
    classNames() {
      const pillClasses = [
        'nr-pill',
        `nr-pill--${this.size}`,
        `nr-pill--${this.pillColor}`
      ]

      return pillClasses
    }
  }
}
